import React from 'react';
import { oneOf, string } from 'prop-types';
import cx from 'classnames';

const spaces = [
  'none',
  'xxsmall',
  'xsmall',
  'small',
  'large',
  'xlarge',
  'xxlarge',
];

export const propTypes = {
  /** Tagname for element */
  tag: string,
  /** Color of the background */
  color: oneOf([
    'primary',
    'secondary',
    'tertiary',
    'quaternary',
    'black',
    'grey',
    'white',
  ]),
  /** Top and bottom spaces */
  space: oneOf(spaces),
  /** Top space separately */
  spaceTop: oneOf(spaces),
  /** Bottom space separately */
  spaceBottom: oneOf(spaces),
};

const CLASS_ROOT = 'section';

const Section = ({
  children,
  className,
  tag = 'section',
  color,
  space,
  spaceTop,
  spaceBottom,
  ...other
}) => {
  const classes = cx(
    CLASS_ROOT,
    {
      [`${CLASS_ROOT}--${color}`]: color,
      [`${CLASS_ROOT}-p--${space}`]: space,
      [`${CLASS_ROOT}-pt--${spaceTop}`]: spaceTop,
      [`${CLASS_ROOT}-pb--${spaceBottom}`]: spaceBottom,
    },
    className
  );
  const Tag = tag;

  return (
    <Tag className={classes} {...other}>
      {children}
    </Tag>
  );
};

Section.propTypes = propTypes;
Section.displayName = 'Section';

export default Section;



// WEBPACK FOOTER //
// ./src/components/Section/Section.js